module.exports = __webpack_public_path__ + "img/empty.b2eb6cec.png";